<template>
  <div class="header-delivery-time">
    <div class="header-delivery-time__text">Доставка ~60 минут</div>

    <nuxt-link
      class="header-delivery-time__link"
      to="/delivery/"
      :prefetch="false"
    >
      Рассчитать для меня
    </nuxt-link>
  </div>
</template>

<style lang="scss" scoped>
.header-delivery-time {
  color: var(--ui-text-primary);

  &__text {
    margin-bottom: 3px;
    font-size: 12px;
    font-weight: 800;

    @include media('>=desktop') {
      font-size: 14px;
    }
  }

  &__link {
    display: block;
    font-size: 10px;
    font-weight: 600;
    line-height: 15px;
    color: inherit;

    @include media('>=desktop') {
      font-size: 13px;
    }
  }
}
</style>
